import React from "react";
import { useTranslation } from "react-i18next";
import { REQUEST_TYPES } from "shared/config";

/**
 * Hook to transform currencies data into options suitable for a select input.
 * If OCR is applicable (if currenciesHints is not an empty Array),
 * different hints will be added to the select input depending on the request type.
 *
 * @param {object} options - Hook options.
 * @param {object} options.dependencies - Object containing currency data.
 * @param {string} options.requestType - Type of request.
 * @returns {array} - Array of currency options.
 */
export function useCurrenciesOptions({ dependencies, requestType }) {
  const { t } = useTranslation("CostLine");
  const currencies = dependencies?.currencies?.data;
  const currenciesHints = dependencies?.currencies_hints;

  const currenciesOptions = React.useMemo(() => {
    if (!currencies || currencies?.length === 0) return [];
    const options = currencies.map(({ code }) => ({
      value: code,
      label: code,
    }));
    if (currenciesHints?.length > 0) {
      return [
        {
          label:
            requestType === REQUEST_TYPES.TRAVEL
              ? t("labels.currencies_from_travel_plan")
              : t("labels.most_popular_currencies"),
          options: currenciesHints.map((currency) => ({
            value: currency,
            label: currency,
          })),
        },
        {
          label: t("labels.currencies"),
          options,
        },
      ];
    } else return options;
  }, [currencies, currenciesHints, requestType]);

  return currenciesOptions;
}
